import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'
import { SignFileParams } from './shared/types'

export function useSignFile() {
  const { server } = useServer()
  const client = useQueryClient()
  return useMutation({
    mutationFn: signFile,
    onSuccess: async (_, { fileId }) => {
      const fileDetailsKey = keys.file(fileId)
      await client.invalidateQueries({ queryKey: fileDetailsKey })
    },
  })

  async function signFile({ fileId }: SignFileParams) {
    await server.post(`/v2/chat/repository/files/${fileId}/sign`, {}, 'user')
  }
}
